class NostoCarousel extends window.PURELEI.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const fallbackProducts = JSON.parse(this.els.products.element.innerText)

    // Using a setTimeout here as the customerPrivacy object is not available immediately
    setTimeout(() => {
      let marketing;
      try {
        marketing = window.Shopify.customerPrivacy.currentVisitorConsent().marketing
      } catch (e) {
        marketing = false;
      }

      if (!!marketing === false && fallbackProducts.length > 0) {
        this.els.nosto.element.innerHTML = this.els.fallback.element.innerHTML
      }

      this.els.fallback.element.remove()
    }, 1000)
  }
}

if (!customElements.get('nosto-carousel')) {
  customElements.define('nosto-carousel', NostoCarousel)
}
